module.exports = __webpack_public_path__ + "img/goCarCredit-logo.379e662c.png";